<template>
  <div class="page-container">
    <div class="header">
      <div class="pss">
        <!-- <img src="@assets/actimg/pss.png" alt="" class="pssimg"> -->
        每日特惠
      </div>
      <div class="header_btn">
        <div class="jrdp" @click="showPopup = true">活动规则</div>
      </div>
    </div>
    <div class="banner">
      <div class="pro">
        <div class="pro_lis" v-for="item in mrth" :key="item.id" @click="goDetail(item.id)">
          <div class="lis_img">
            <img :src="item.img" alt="" class="pro1">
          </div>
          <div class="jt">
            <div class="jtimg">
              <img src="@assets/actimg/jiangjia.png" alt="" class="jiangjia">
            </div>
            <div class="jttext">限量直降{{(item.oldprice-item.price).toFixed(2) }}元</div>
            
          </div> 
          
          <div class="jtbtn">
              <div class="btn_price">
                <span style="font-size: 12px;">￥</span>
                <span style="font-size: 14px;">{{item.price}}</span>
                <span style="font-size: 12px;">.0</span>
              </div>
          </div>
        </div>
        
       
        
      </div>
      
    </div>
    <div class="jrth">
      <span style="font-size: 24px;font-weight: bold;">今日特惠     </span>
      <span style="font-size: 18px;">10:00开抢</span>
    </div>
    <div class="product">
      <div class="product_title">
          家电特惠专区
      </div>
      <div class="product_list">
        <div class="list_p" v-for="(item,index) in jdth"  @click="goDetail(item.id)" style="margin-top: 5px;">
          <div class="p_img">
            <img :src="item.img" alt="" class="pp_img">
          </div>
          <div class="p_w">
            <div class="w_title">
              <span style="color: #6E4E1C;background-color: #FEDA67;padding: 5px; font-size: 10px;">分期免息</span>
              {{item.name}}
            </div>
            <div class="w_price">
              <div class="pri">
                <div>到手价</div>
                <div>￥{{item.price}}</div>
              </div>
              <div class="fenqi">
                <span style="font-size: 12px;font-weight: bold;">￥</span>
                <span style="font-size: 18px;font-weight: bold;">{{(item.price/12).toFixed(2)}}</span>
                <span style="font-size: 12px;">*12期</span>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="product">
      <div class="product_title">
          手机数码特惠专区
      </div>
      <div class="product_list">
        <div class="list_p" v-for="(item,index) in sjsmth"  @click="goDetail(item.id)" style="margin-top: 5px;">
          <div class="p_img">
            <img :src="item.img" alt="" class="pp_img">
          </div>
          <div class="p_w">
            <div class="w_title">
              <span style="color: #6E4E1C;background-color: #FEDA67;padding: 5px; font-size: 10px;">分期免息</span>
              {{item.name}}
            </div>
            <div class="w_price">
              <div class="pri">
                <div>到手价</div>
                <div>￥{{item.price}}</div>
              </div>
              <div class="fenqi">
                <span style="font-size: 12px;font-weight: bold;">￥</span>
                <span style="font-size: 18px;font-weight: bold;">{{item.fenqi==6?(item.price/item.fenqi).toFixed(2):(item.price/12).toFixed(2)}}</span>
                <span style="font-size: 12px;">*{{item.fenqi?item.fenqi:'12'}}期</span>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    


    <div class="product">
      <div class="product_title">
          家居特惠专区
      </div>
      <div class="product_list">
        <div class="list_p" v-for="(item,index) in jjth"  @click="goDetail(item.id)" style="margin-top: 5px;">
          <div class="p_img">
            <img :src="item.img" alt="" class="pp_img">
          </div>
          <div class="p_w">
            <div class="w_title">
              <span style="color: #6E4E1C;background-color: #FEDA67;padding: 5px; font-size: 10px;">分期免息</span>
              {{item.name}}
            </div>
            <div class="w_price">
              <div class="pri">
                <div>到手价</div>
                <div>￥{{item.price}}</div>
              </div>
              <div class="fenqi">
                <span style="font-size: 12px;font-weight: bold;">￥</span>
                <span style="font-size: 18px;font-weight: bold;">{{(item.price/12).toFixed(2)}}</span>
                <span style="font-size: 12px;">*12期</span>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="product">
      <div class="product_title">
          美妆特惠专区
      </div>
      <div class="product_list">
        <div class="list_p" v-for="(item,index) in mzth"  @click="goDetail(item.id)" style="margin-top: 5px;">
          <div class="p_img">
            <img :src="item.img" alt="" class="pp_img">
          </div>
          <div class="p_w">
            <div class="w_title">
              <span style="color: #6E4E1C;background-color: #FEDA67;padding: 5px; font-size: 10px;">分期免息</span>
              {{item.name}}
            </div>
            <div class="w_price">
              <div class="pri">
                <div>到手价</div>
                <div>￥{{item.price}}</div>
              </div>
              <div class="fenqi">
                <span style="font-size: 12px;font-weight: bold;">￥</span>
                <span style="font-size: 18px;font-weight: bold;">{{(item.price/12).toFixed(2)}}</span>
                <span style="font-size: 12px;">*12期</span>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="product">
      <div class="product_title">
          腕表黄金特惠专区
      </div>
      <div class="product_list">
        <div class="list_p" v-for="(item,index) in wbth"  @click="goDetail(item.id)" style="margin-top: 5px;">
          <div class="p_img">
            <img :src="item.img" alt="" class="pp_img">
          </div>
          <div class="p_w">
            <div class="w_title">
              <span style="color: #6E4E1C;background-color: #FEDA67;padding: 5px; font-size: 10px;">分期免息</span>
              {{item.name}}
            </div>
            <div class="w_price">
              <div class="pri">
                <div>到手价</div>
                <div>￥{{item.price}}</div>
              </div>
              <div class="fenqi">
                <span style="font-size: 12px;font-weight: bold;">￥</span>
                <span style="font-size: 18px;font-weight: bold;">{{(item.price/12).toFixed(2)}}</span>
                <span style="font-size: 12px;">*12期</span>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
<div class="demo-page">
    <!-- 触发按钮 -->
   
    
    <!-- 弹出层组件 -->
    <MobilePopup 
      :visible="showPopup"
      @close="showPopup = false"
      content-width="90%"
      :border-radius="16"
    >
      <!-- 自定义弹出层内容 -->
     
    </MobilePopup>
  </div>
  </div>

   
</template>

<script>
import { goShopDetail } from "@libs/order";
import MobilePopup from './MobilePopup.vue'
export default {
  name: 'Activity1',
  components: {
    MobilePopup
  },
  data() {
    return {
      showPopup:false,
      mrth:[
        {
            id:123,
            name:'海尔兄弟（HAIERBROS） 保温杯HB-BT101A',
            price:'19.9',
            oldprice:'39',
            img:'https://bank.giftoceanmall.com/uploads/attach/2026/01/20260122/91611e86ef5a50ebccaac7a270099d58.jpg',
        },
        {
            id:231,
            name:'追觅X50Pro滚筒版扫地机器人扫拖洗烘一体自清洗加长滚筒洗地机器人上下水版RLS42CE-1',
            price:'3599',
            oldprice:'4199',
            img:'https://bank.giftoceanmall.com/184da202605271348068351.png',
        },
        {
            id:173,
            name:'美的（Midea）【一键闪装】变频直流电风扇 家用立式一级能效落地扇卧室客厅大风力轻音低噪小型风扇 SDJ30BM',
            price:'229',
            oldprice:'229',
            img:'https://bank.giftoceanmall.com/eb5a4202605091639442898.jpg',
        },
        {
            id:135,
            name:'飞利浦3c认证磁吸magsafe充电宝便携迷你超薄适用于苹果16无线快充移动电源DLP9505小巧飞机可携带 5000毫安',
            price:'119',
            oldprice:'139',
            img:'https://bank.giftoceanmall.com/a30b6202604241408326941.png',
        },
        {
            id:230,
            name:'美的（Midea）电饭煲家用4升精铁釜大容量米饭锅智能预约3-4人IH多功能煮小米粥蒸米饭电饭锅AFB40C8',
            price:'398',
            oldprice:'498',
            img:'https://bank.giftoceanmall.com/20f9f202605261504591448.jpg',
        },
        {
            id:243,
            name:'纽曼N70S-32G大内存大电量超长待机苹果手机颜值高性能手机',
            price:'448',
            oldprice:'499',
            img:'https://bank.giftoceanmall.com/cbf67202605271815484596.jpg',
        }

      ],
        jdth:[
        {
          id:3,
          name:'海尔（Haier）空气炸锅 大容量家用煎炸锅 低油轻脂不粘大功率空气烤箱多功能薯条机电炸锅JL30D升',
          price:'189',
          oldprice:'299',
          img:'https://bank.giftoceanmall.com/7353d202606021640244609.jpg',
          
        },
        {
          id:140,
          name:'海尔（Haier）电动牙刷 HTA2-HYB小摩刷 皓月白',
          price:'59',
          oldprice:'99',
          img:'https://bank.giftoceanmall.com/20cef202606021639292780.png',
          
        },
        {
          id:236,
          name:'追觅自集尘吸尘器Z10Station旋锋版MAX 家用手持 210AW大吸力 除菌基站 割毛防缠绕',
          price:'1499',
          oldprice:'1999',
          img:'https://bank.giftoceanmall.com/88d2d202605271457377755.jpg',
          
        },
        {
          id:226,
          name:'美的（Midea）电饭煲低糖饭低卡 IH智能Pro电饭锅4-5人家用4L大容量WIFI智控养生蒸米饭锅40LS60',
          price:'439',
          oldprice:'499',
          img:'https://bank.giftoceanmall.com/301b0202605261423337591.jpg',
          
        },
        {
          id:179,
          name:'美的（Midea）【品质推荐】七叶轻音柔风电风扇/家用省电落地扇/台式电扇/广角摇头节能宿舍小型风扇 SAE35CA',
          price:'149',
          oldprice:'189',
          img:'https://bank.giftoceanmall.com/13d91202605091709238117.jpg',
          
        },
        {
          id:67,
          name:'美的（Midea）大容量1.7L电水壶SH17DG02',
          price:'84',
          oldprice:'99',
          img:'https://www.giftoceanmall.com/uploads/attach/2025/09/20250919/567fd9cfe705440260dc63de509e2dfe.jpg',
          
        },
        {
          id:44,
          name:'海尔（Haier）电风扇家用无叶风扇节能省电客厅卧室立式落地扇直流变频塔扇HFW-Y09 【直流变频32挡风速】遥控款HFW-J09',
          price:'549',
          oldprice:'649',
          img:'https://bank.giftoceanmall.com/21533202606021637348181.jpg',
          
        },
        {
          id:38,
          name:'海尔(Haier)颈椎按摩器肩颈按摩仪颈部斜方肌腰部背部揉捏热敷礼物 X602Z（米色）',
          price:'169',
          oldprice:'199',
          img:'https://www.giftoceanmall.com/uploads/attach/2025/06/20250609/057742fee607415b732524e0069afa47.jpg',
          
        },
     
        {
          id:164,
          name:'海尔（Haier）吸尘器自集尘基站HF3家用手持无线大吸力集尘管家绿光除螨毛发防缠节日礼物HSC-SA301D',
          price:'999',
          oldprice:'1299',
          img:'https://bank.giftoceanmall.com/636b8202606021638237846.png',
          
        },
        
        
        
      ],
      sjsmth:[
        {
          id:245,
          name:'荣耀Magic8 Pro 16+1TB 第五代骁龙8至尊版 2亿超清夜神长焦 双3D解锁 5G AI手机',
          price:'6699',
          oldprice:'6999',
          img:'https://bank.giftoceanmall.com/1183520260601134334586.jpg',
          fenqi:6,
        },
        {
          id:246,
          name:'华为畅享80 大内存256GB 大电池6620mAh电池超能续航 玄甲架构 双五星超耐摔 华为手机鸿蒙系统',
          price:'1279',
          oldprice:'1399',
          img:'https://bank.giftoceanmall.com/2dc21202606011401288828.jpg',
          fenqi:6,
        },
        {
          id:243,
          name:'纽曼N70S-32G大内大内存超长待机苹果手机苹果机高颜值高性能手机',
          price:'448',
          oldprice:'599',
          img:'https://bank.giftoceanmall.com/cbf67202605271815484596.jpg',
          fenqi:6,
        },
        {
          id:238,
          name:'纽曼A100大声音老年机学生机手机10000毫安大容量电池',
          price:'239',
          oldprice:'299',
          img:'https://bank.giftoceanmall.com/75808202605271746269331.jpg',
          fenqi:6,
        },
        
        {
          id:157,
          name:'飞利浦（PHILIPS）骨传导概念挂耳挂耳式耳夹开放式不入耳式运动跑步蓝牙耳耳机长续航高端降噪通用苹果华为TAA1708黑/白',
          price:'199',
          oldprice:'241',
          img:'https://bank.giftoceanmall.com/42b77202606021627464741.jpg',
          
        },
        {
          id:153,
          name:'飞利浦（PHILIPS）真无线蓝牙耳机手机通话降噪运动跑步重低音音乐苹果安卓华为小米手机圣诞礼物TAT1168',
          price:'199',
          oldprice:'251',
          img:'https://www.giftoceanmall.com/uploads/attach/2026/02/20260203/f7c2f3d1aea8888ecd5d58120a820cce.jpg',
          
        },
        {
          id:208,
          name:'摩米士（MOMAX）磁吸音响便携磁吸支架手机无线蓝牙音箱户外迷你外迷你音箱 【磁吸外挂音响】升级版蓝牙BS7',
          price:'129',
          oldprice:'199',
          img:'https://bank.giftoceanmall.com/e1aa220260519134751198.jpg',
          
        },
       
        {
          id:154,
          name:'韶音（SHOKZ）OpenRun Air S803骨传导耳机黑/紫',
          price:'489',
          oldprice:'697',
          img:'https://www.giftoceanmall.com/uploads/attach/2026/02/20260203/ed152b128939497a6777672e82580985.jpg',
        },
      ],
      smth:[
         {
          id:157,
          name:'飞利浦（PHILIPS）骨传导概念耳夹式运动跑步蓝牙耳机长续航高端降噪',
          price:'199',
          img:'https://bank.giftoceanmall.com/uploads/attach/2026/02/20260203/7e8d32747a943fd9aee010bb31ffb4e4.jpg',
        },
        {
          id:153,
          name:'飞利浦（PHILIPS）真无线蓝牙耳机手机通话降噪运动跑步重低音音乐TAT1168',
          price:'199',
          img:'https://bank.giftoceanmall.com/uploads/attach/2026/02/20260203/f7c2f3d1aea8888ecd5d58120a820cce.jpg',
        },
        {
          id:135,
          name:'飞利浦3c认证磁吸magsafe充电宝便携迷你无线快充移动电源DLP9505 骑士灰 5000毫安',
          price:'119',
          img:'https://bank.giftoceanmall.com/uploads/attach/2026/02/20260203/784cab36b375c1ca2cc8dcdf0f75037d.jpg',
        },
        {
          id:155,
          name:'韶音（SHOKZ）OpenFit Air T511开放式耳机挂耳式蓝牙耳机黑/白',
          price:'419',
          img:'https://bank.giftoceanmall.com/uploads/attach/2026/02/20260203/c102c909bbdc02def578fb7ed93a55ea.jpg',
        },
        {
          id:154,
          name:'韶音（SHOKZ）OpenRun Air S803骨传导耳机黑/紫',
          price:'489',
          img:'https://bank.giftoceanmall.com/uploads/attach/2026/02/20260203/ed152b128939497a6777672e82580985.jpg',
        },
       
      ],
      jjth:[
        {
          id:129,
          name:'蔬果园家居清洁系列礼盒9件套A-22',
          price:'89',
          img:'https://bank.giftoceanmall.com/uploads/attach/2026/01/20260122/1a60aaf044ec2208a251e19805e67ac2.jpg',
        },
        {
          id:130,
          name:'蔬果园香雪苍兰香氛洗衣凝珠-8g*52颗',
          price:'22.9',
          img:'https://bank.giftoceanmall.com/uploads/attach/2026/01/20260122/cf62a2e2fc46fd891132615ffe8ee717.png',
        },
        {
          id:81,
          name:'SukGarden蔬果园橘彩星光果蔬餐具净1+1特惠装（半透瓶）800g*2',
          price:'22.9',
          img:'https://bank.giftoceanmall.com/uploads/attach/2025/09/20250924/d16c03f929a075582a5194f8a01a39b2.png',
        },
        {
          id:139,
          name:'公牛BULL TQU006盒装黑色大魔方插座(8979)3*1.0-1.8m',
          price:'79',
          img:'https://bank.giftoceanmall.com/uploads/attach/2026/02/20260203/60886d2fe05d8c62fa86a4f673b5640d.jpg',
        },
        {
          id:137,
          name:'公牛（BULL）S1120新国标插座 3位总控全长1.8米',
          price:'59',
          img:'https://bank.giftoceanmall.com/uploads/attach/2026/02/20260203/a5aabc3109c0e85471991228612e5682.jpg',
        },
        {
          id:138,
          name:'公牛BULL 218(S)吸塑装延长线插座(2459)3*1.0*5m*10H',
          price:'85',
          img:'https://bank.giftoceanmall.com/uploads/attach/2026/02/20260203/0b6d99f259451bd2fb18cc3241f13029.jpg',
        },
        
      ],
      mzth:[
        {
          id:151,
          name:'完美日记 仿生膜精华哑光口红 901',
          price:'109',
          img:'https://bank.giftoceanmall.com/uploads/attach/2026/02/20260203/6136d65f8160a53445c0f63b5b285f9b.jpg',
        },
        
        {
          id:119,
          name:'完美日记 倾色慕光唇膏迷你套组 （升级版）',
          price:'74',
          img:'https://bank.giftoceanmall.com/uploads/attach/2026/01/20260122/6f8d9b2a6dbbcd7868af7292d186232a.jpg',
        },
        {
          id:120,
          name:'完美日记 恣意出色丝绒细管口红',
          price:'76',
          img:'https://bank.giftoceanmall.com/uploads/attach/2026/01/20260122/2d834a7e35c8a557f1b9e60002443f0b.jpg',
        },
        {
          id:118,
          name:'完美日记精华水润素颜霜30g',
          price:'99',
          img:'https://www.giftoceanmall.com/uploads/attach/2026/01/20260122/35f01ce6723689aa58b99e91562b31cc.jpg',
        },
      ],
      wbth:[
        {
          id:148,
          name:'TISSOT天梭 力洛克系列钢带机械手表男士腕表 T006.407.11.033.00',
          price:'4999',
          img:'https://bank.giftoceanmall.com/uploads/attach/2026/02/20260203/924dc2034292f00b3962a7b0092e3264.jpg',
        },
        {
          id:145,
          name:'Tissot天梭 嘉丽系列钢带机械女表刘亦菲同款情人节礼物(发光吧！小美人） T126.207.36.013.00',
          price:'5399',
          img:'https://bank.giftoceanmall.com/uploads/attach/2026/02/20260203/44c9be21987e981b6af0b3ebad6d8868.jpg',
        },
         {
          id:147,
          name:'Tissot天梭 魅时系列石英手表女士腕表 T143.210.17.091.00',
          price:'1899',
          img:'https://bank.giftoceanmall.com/uploads/attach/2026/02/20260203/00357558c351a232a977d77842d6a7b3.jpg',
        },
        {
          id:146,
          name:'Tissot天梭 力洛克系列机械手表男士腕表(黄晓明同款) T006.407.11.043.00',
          price:'4499',
          img:'https://bank.giftoceanmall.com/uploads/attach/2026/02/20260203/c9272fbdc64b5fbf303f25ffb0844dba.jpg',
        },
        {
          id:149,
          name:'TISSOT天梭 乐爱系列钢带石英女士腕表(19.5mm) T058.009.11.051.00',
          price:'2299',
          img:'https://bank.giftoceanmall.com/uploads/attach/2026/02/20260203/0e4039a40ffb763f43db54b0f8c05adb.jpg',
        },
        {
          id:107,
          name:'周大生 黄金足金一路有你吊坠约 0.4g',
          price:'999',
          img:'https://www.giftoceanmall.com/uploads/attach/2025/11/20251105/f71962f13fc239b6b5e57e933173c837.jpg',
        },
        {
          id:105,
          name:'周大生 铃兰花黄金项链女足金蝴蝶结套链吊坠结婚三金婚嫁金首饰约 9.01g',
          price:'14999',
          img:'https://www.giftoceanmall.com/uploads/attach/2025/11/20251105/7d8a4f3facc9b03445a0661449ab89ad.jpg',
        },
       
      ],
    }
      
  },
  methods: {
    goDianpu() {
      
     
        this.$router.push({ path: "/"});
    
    },
    goDetail(id) {
      console.log(id);
      goShopDetail(id).then(() => {
        this.$router.push({ path: "/detail/" + id });
      });
    },
  }
}
</script>

<style scoped lang="scss">
.page-container{
  width: 100%;
  height: auto;
}
.header{
  width: 100%;
  height: 60px;
  background-color: #D73124;
  display: flex;
  justify-content: space-between;
  .pss{
    padding-left: 14px;
    padding-top: 17px;
    color: #fff;
    font-size: 20px;
    font-weight: bold;
    .pssimg{
      width: 70px;

    }
  }
  .header_btn{
    width: 111px;
    padding-top: 14px;
    // padding-right: 20px;
    .jrdp{
      width: 100px;
      height: 35px;
      line-height: 35px;
      text-align: center;
      background-color: #FEFAD6;
      border-radius: 5px;
      font-size: 18px;
      font-weight: 500;
      color: #EF1511;

    }
  }
  
}
.banner{
    width: 100%;
    height: 170px;
    background-color: #D73124;
    .pro{
      width: 100%;
      height: 160px;
      background-color: #fff;
      border-radius: 0 0 10px 10px;
      display: flex;
      overflow-x: auto;
      overflow-y: hidden;
      white-space: nowrap;
      scrollbar-width: none; /* 隐藏滚动条 */
      -webkit-overflow-scrolling: touch; /* 平滑滚动 */
      &::-webkit-scrollbar {
        display: none; /* 隐藏滚动条 */
      }
      .pro_lis{
          display: inline-block;
          width: 100px;
          margin: 0 10px;
          flex-shrink: 0;
          padding-top: 10px;
          padding-bottom: 10px;
          .lis_img{
            width: 100px;
            .pro1{
              width: 100px;
              height: 100px;
            }
          }
          .jt{
            width: 100px;
            display: flex;
            .jiangjia{
              width: 12px;
              // height: 27px;
            }
            .jttext{
              margin-left: 10px;
              color: #D73236;
              font-size: 10px;

            }
          }
          .jtbtn{
            width: 100px;
            height: 24px;
            background: url(../../assets/actimg/qiang.png) no-repeat;
            background-size: 100px;
            .btn_price{
              color: #D73236;
              font-weight: bold;
              line-height: 24px;
              padding-left: 6px;
            }
          }
        }
    }
}
.jrth{
  width: 100%;
  height: 60px;
  background: #D73124;
  text-align: center;
  line-height: 60px;
  color: #fff;
  margin-top: 5px;
}
.product{
  width: 100%;
  background: #f1f1f1;
  height: auto;
  .product_title{
    width: 100%;
    height: 60px;
    font-size: 18px;
    text-align: center;
    position: relative; /* 作为伪元素的定位参考 */
    padding-bottom: 6px; /* 文字和下划线的间距，可调整 */
    line-height: 60px;
    color: #D73124;
    font-weight: bold;
    display: inline-block; /* 关键：让容器宽度适配文字，否则会占满整行 */
    border-radius: 10px 10px 0 0;
  }
  .product_title::after{
    content: '';
    position: absolute;
    bottom: 9px; /* 下划线在文字底部 */
    left: 50%; /* 先把伪元素左侧定位到容器中点 */
    transform: translateX(-50%); /* 向左偏移自身50%，实现整体居中 */
    
    /* 自定义下划线样式 */
    width: 30px; /* 下划线长度，可自定义 */
    height: 3px; /* 下划线粗细 */
    background-color: #D73124; /* 下划线颜色 */
    border-radius: 2px; 
  }
}
.product_list{
  width: 100%;
  background: #f1f1f1;
  height: auto;
  .list_p{
    width: 95%;
    height: 140px;
    margin: 0 auto;
    background: #fff;
    border-radius: 5px;
    display: flex;
    .p_img{
      margin-top: 5px;
      width: 130px;
      height: 130px;
      margin-left: 5px;
      border-radius: 5px;
      .pp_img{
        width: 130px;
        height: 130px;
       
      }
    }
    .p_w{
      padding-top: 10px;
      padding-left: 5px;
      position: relative;
      .w_title{
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
            overflow: hidden;
            white-space: normal;
            word-break: break-word;
            line-height: 1.4;
            max-height: 4.2em;
          }
          .w_price{
        display: flex;
        width: 210px;
        margin-top: 30px;
        background: url(../../assets/actimg/price.png) no-repeat;
        background-size: 210px;
        height: 43px;
        position: absolute;
        bottom: 10px;
        // margin-left: 10px;
        .pri{
          color: #526079;
          font-size: 11px;
          margin-left: 5px;
          margin-top: 5px;

        }
        .fenqi{
          color: #D73124;
          margin-left: 20px;
          line-height: 43px;
        }
      }
    }
  }

}
.demo-page {
  padding: 20px;
}

.popup-demo-content {
  text-align: center;
}

button {
  padding: 8px 16px;
  background: #409eff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
</style>